import InlineComponent from './inlineComponent.jsx';
import RQLSearchHtmx from '../../../components/rql/RQLSearchHtmx.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = RQLSearchHtmx;
  }
};
